import { AlertTriangle, Home, RefreshCcw } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { sendCustomEvent, sendErrorEvent } from '@Analytics';
import { FullPageStatus } from '@Components/FullPageStatus';

interface ErrorMessageProps {
  message?: string;
  internalMessage: string;
}

const ErrorMessage = ({ message, internalMessage }: ErrorMessageProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  sendErrorEvent(internalMessage);

  const fullMessage = t(message || 'Global.ErrorMessage');
  const [title, ...descriptionLines] = fullMessage.split('\n');
  const description = descriptionLines.join('\n');

  const tryAgain = () => {
    sendCustomEvent('BUTTON_CLICKED', { buttonName: 'TRY_AGAIN', internalMessage });
    window.location.reload();
  };

  const goHome = () => {
    sendCustomEvent('BUTTON_CLICKED', { buttonName: 'GO_HOME', internalMessage });
    navigate('/');
  };

  return (
    <FullPageStatus
      watermark="500"
      tone="error"
      icon={AlertTriangle}
      title={title}
      description={description}
      actions={[
        { label: t('Global.TryAgain'), icon: RefreshCcw, variant: 'secondary', onClick: tryAgain },
        { label: t('Global.GoHome'), icon: Home, variant: 'primary', onClick: goHome },
      ]}
    />
  );
};

ErrorMessage.defaultProps = {
  message: undefined,
};

export default ErrorMessage;
